export default __webpack_public_path__ + "static/media/banner1.81a04502.png";